import React, { useState } from 'react';
import { Input } from 'antd';

import './index.css';

const FloatInput = (props: any) => {
  const [focus, setFocus] = useState(false);
  let {  formik, label, value, placeholder, type, required, name, multiLine, autoSize, disabled = false, onChangeHandler, divStyle=null, size="default" } = props;

  
  if (formik) {
    onChangeHandler = formik.handleChange(name);
    value = formik.values[name];
  }

  if (!placeholder) placeholder = label;

  const isOccupied = focus || (value && value.length !== 0);

  const labelClass = isOccupied ? 'label as-label' : 'label as-placeholder';

  const requiredMark = required ? <span className="text-danger">*</span> : null;
  const { TextArea } = Input;
  return (
    <div
    style={divStyle}
      className="float-label"
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      {
        multiLine ? <TextArea
          onChange={onChangeHandler}
          //type={type}
          value={value}
          autoSize={autoSize}
          style={props.style}
          // {...props}
        /> :
          <Input          
      // {...props}

            style={props.style}
            onChange={onChangeHandler}
            type={type}
            value={value}
            disabled={disabled}
            size={size}
          />
      }

      <label className={labelClass} style={props.labelStyle}>
        {isOccupied ? label : placeholder} {requiredMark}
      </label>

      {/* {props.errors  && (
        <div className="invalid-feedback d-block">{props.errors.message}</div>
      )} */}

      {formik && formik.errors[name] && formik.touched[name] && (
        <div className="invalid-feedback d-block">{formik.errors[name]}</div>
      )}
    </div>
  );
};

export default React.memo(FloatInput);
